import React from "react";
import Logo from "./Logo";
import { PHONE_DISPLAY, PHONE_TEL } from "../data/mock";
import { Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-cream grain px-5 md:px-8 pt-14 pb-10">
      <div className="max-w-[1240px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <Logo size={38} />
          <div className="flex flex-wrap items-center gap-x-3 gap-y-2 text-sm text-navy/60">
            <span>AI-assisted call handling for service businesses.</span>
            <span className="text-navy/30">•</span>
            <a href="#faq" className="hover:text-navy transition-colors">FAQ</a>
            <a href="#pricing" className="hover:text-navy transition-colors">Pricing</a>
          </div>
          <a
            href={`tel:${PHONE_TEL}`}
            className="flex items-center gap-2 text-navy font-medium hover:text-teal transition-colors"
          >
            <Phone className="w-4 h-4 text-teal" />
            <span className="font-mono">{PHONE_DISPLAY}</span>
          </a>
        </div>

        <div className="mt-10 pt-6 border-t border-navy/10 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
          <p className="font-mono text-xs text-navy/50">© 2026 CallRetrieve. All rights reserved.</p>
          <p className="font-mono text-xs text-navy/50">Built for the calls you can't afford to miss.</p>
        </div>
      </div>
    </footer>
  );
}
